import Table from 'react-bootstrap/Table';
import { Badge, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { useGetB2BInvoiceList } from '../apiEndpoints/b2bBuyerSellerEndpoint';
import CommonStatus from '../../../Components/Common/CommonStatus';
import { Link } from 'react-router-dom';
import { encodeData } from '../../../Components/Common/utility/commonUtility';
import CommonOnlinePayment from '../../Common/Payment/CommonOnlinePayment';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';

const B2BInvoice = () => {
  const { data, isLoading } = useGetB2BInvoiceList();
  const {
    state: { b2bUser },
    dispatch: b2bAuthDispatch,
  } = B2BAuthContext();
  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        <h4 className='component-tittle'>Invoice Information</h4>
        <div className='profile-right-info pt-3 ps-2'>
          {isLoading ? (
            <div className='text-center mt-3'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <Table striped bordered hover size='sm'>
              <thead>
                <tr className='text-center'>
                  <th>SL.</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((invoice, index) => (
                  <tr className='text-center' key={invoice.id}>
                    <td>{index + 1}</td>
                    <td>{moment(invoice.invoice_date).format('MMM Do YY')}</td>
                    <td>{invoice.net_total}</td>
                    <td>{CommonStatus(invoice.status)}</td>
                    <td>
                      <CommonOnlinePayment
                        invoiceId={invoice.id}
                        userId={b2bUser?.b2b_id}
                        userType={'B2B'}
                        isPaid={
                          invoice.status === 'Paid' ? 'Paid' : undefined
                        }
                      />
                      {/* {invoice.status === 'Paid' ||
                      invoice.status === 'Under Review' ? (
                        <Badge
                          bg={'primary'}
                          text={'light'}
                          style={{
                            fontSize: '12px',
                            cursor: 'pointer',
                            marginRight: '3px',
                          }}
                        >
                          Already Paid
                        </Badge>
                      ) : (
                        <Link
                          to={`/b2b/payment-management?value=${encodeData({
                            amount: invoice.due,
                            invoice_id: invoice.id,
                          })}`}
                        >
                          <Badge
                            bg={'primary'}
                            text={'light'}
                            style={{
                              fontSize: '12px',
                              cursor: 'pointer',
                              marginRight: '3px',
                            }}
                          >
                            Pay Now
                          </Badge>
                        </Link>
                      )} */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};

export default B2BInvoice;
